<div id="background">
  <a routerLink="/">
    <img src="../../assets/logowhite.svg" alt="dots n pix logo" id="logoSmall">
  </a>

  <div class="building">
    <div class="door"></div>
    <div class="floors">
      <div class="floor" *ngFor="let spreker of sprekers">
        <div class="windows">
          <div class="window"></div>
          <div class="window"></div>
          <div class="window"></div>
          <div class="window"></div>
          <div class="window"></div>
          <div class="window"></div>
        </div>
        <a [routerLink]="'/speaker/' + spreker['name']">{{spreker["name"]}}</a>
      </div>
    </div>
  </div>

</div>
